/**
 * @generated SignedSource<<57e1632b3812c8d39270032f01851e9d>>
 * @relayHash c287d50f74eaa1bc324ed883fc50b992
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e0ad4f1c57fdb45b512c8a9f04e15dd64287d9fc05258fda5b73a81f4e9bc36d

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GSNForContentSidebarQuery$variables = {
  cloudId: string;
  entityAriProjects: string;
  entityAriUserSideNavSettings: string;
  isAppsExpanded?: boolean | null | undefined;
  isFiltersExpanded?: boolean | null | undefined;
  isOperationsExpanded?: boolean | null | undefined;
  isOverviewsExpanded?: boolean | null | undefined;
  isPlansExpanded?: boolean | null | undefined;
  isProjectsExpanded?: boolean | null | undefined;
  navPlatMenuDataEntityAri: string;
  navPlatSidebarDataEntityAri: string;
  ownerAri?: string | null | undefined;
};
export type GSNForContentSidebarQuery$data = {
  readonly navPlatL1MenuData: {
    readonly " $fragmentSpreads": FragmentRefs<"useNavSettingsService">;
  } | null | undefined;
  readonly navPlatSidebarData: {
    readonly " $fragmentSpreads": FragmentRefs<"useNavSettingsService">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4Apps" | "Nav4Filters" | "Nav4Operations" | "Nav4Overviews" | "Nav4Plans" | "Nav4Projects" | "useNetworkSideNavUserData">;
};
export type GSNForContentSidebarQuery = {
  response: GSNForContentSidebarQuery$data;
  variables: GSNForContentSidebarQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider": isAllowingEndUsersToAccessCustomTemplates_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcgrw1672displaytargetedjsmtemplatectainnav4relayprovider": nav4ProjectsSectionRecommendationEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider": displaySettingsAPart1Enabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider": displaySettingsPostGaEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider": jiraProjectsSidebarMenuEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider": isJcsProjectMenuEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx": isJpdNav4CommonEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": checkForA11YEnabledFF_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcblu6314draganddropprojectssidebarexperimentrelayprovider": isDragAndDropEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcblu6314draganddropprojectssidebarexperimentrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcgrw1672displaytargetedjsmtemplatectainnav4relayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider: {
    readonly get: () => boolean;
  };
});

import isDragAndDropEnabled_provider from '@atlassian/jira-relay-provider/src/blu-6314-drag-and-drop-projects-sidebar-experiment.relayprovider';
import displaySettingsAPart1Enabled_provider from '@atlassian/jira-relay-provider/src/blu-6315-display-settings-a-part-1.relayprovider';
import displaySettingsPostGaEnabled_provider from '@atlassian/jira-relay-provider/src/blu-6987-display-settings-post-ga-experiment.relayprovider';
import isJpdNav4CommonEnabled_provider from '@atlassian/jira-relay-provider/src/blu-8022-refactor-jpd-project-menu-to-common.relayprovider';
import nav4ProjectsSectionRecommendationEnabled_provider from '@atlassian/jira-relay-provider/src/grw-1672-display-targeted-jsm-template-cta-in-nav4.relayprovider';
import isJcsProjectMenuEnabled_provider from '@atlassian/jira-relay-provider/src/jcs-project-type-m3.relayprovider';
import isAllowingEndUsersToAccessCustomTemplates_provider from '@atlassian/jira-relay-provider/src/jira-custom-template-allow-end-users-to-create-custom-templates.relayprovider';
import checkForA11YEnabledFF_provider from '@atlassian/jira-relay-provider/src/jsm-aiiy-for-nav-item-sidebar.relayprovider';
import jiraProjectsSidebarMenuEnabled_provider from '@atlassian/jira-relay-provider/src/relay-migration-projects-fields-nav4-sidebar.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityAriProjects"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityAriUserSideNavSettings"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isAppsExpanded"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isFiltersExpanded"
},
v5 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isOperationsExpanded"
},
v6 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isOverviewsExpanded"
},
v7 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isPlansExpanded"
},
v8 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isProjectsExpanded"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "navPlatMenuDataEntityAri"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "navPlatSidebarDataEntityAri"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ownerAri"
},
v12 = {
  "kind": "Variable",
  "name": "ownerAri",
  "variableName": "ownerAri"
},
v13 = [
  {
    "kind": "Variable",
    "name": "entityAri",
    "variableName": "navPlatMenuDataEntityAri"
  },
  (v12/*: any*/)
],
v14 = [
  {
    "kind": "FragmentSpread",
    "name": "useNavSettingsService"
  }
],
v15 = [
  {
    "kind": "Variable",
    "name": "entityAri",
    "variableName": "navPlatSidebarDataEntityAri"
  },
  (v12/*: any*/)
],
v16 = {
  "concreteType": "SettingsDisplayPropertyConnection",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "SettingsDisplayProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "key"
        },
        {
          "kind": "ScalarField",
          "name": "value"
        }
      ]
    }
  ]
},
v17 = {
  "kind": "ScalarField",
  "name": "id"
},
v18 = [
  {
    "concreteType": "SettingsMenuItemConnection",
    "kind": "LinkedField",
    "name": "sidebar",
    "plural": false,
    "selections": [
      {
        "concreteType": "SettingsMenuItem",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "menuId"
          },
          {
            "kind": "ScalarField",
            "name": "visible"
          }
        ]
      }
    ]
  },
  (v16/*: any*/),
  (v17/*: any*/)
],
v19 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v20 = [
  (v19/*: any*/)
],
v21 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v22 = {
  "kind": "ScalarField",
  "name": "label"
},
v23 = {
  "kind": "ScalarField",
  "name": "styleClass"
},
v24 = {
  "kind": "ScalarField",
  "name": "url"
},
v25 = {
  "order": "DESC"
},
v26 = {
  "kind": "Literal",
  "name": "first",
  "value": 15
},
v27 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v28 = {
  "kind": "ScalarField",
  "name": "filterId"
},
v29 = {
  "kind": "ScalarField",
  "name": "name"
},
v30 = {
  "kind": "ScalarField",
  "name": "isFavourite"
},
v31 = {
  "kind": "ScalarField",
  "name": "jql"
},
v32 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isEditable"
    },
    {
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": [
        (v21/*: any*/),
        {
          "kind": "ScalarField",
          "name": "accountId"
        },
        (v17/*: any*/)
      ]
    }
  ],
  "type": "JiraCustomFilter"
},
v33 = {
  "kind": "InlineFragment",
  "selections": [
    (v17/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v34 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v35 = {
  "kind": "Literal",
  "name": "first",
  "value": 20
},
v36 = [
  (v17/*: any*/),
  (v29/*: any*/),
  {
    "kind": "ScalarField",
    "name": "alertSearchQuery"
  }
],
v37 = [
  (v24/*: any*/)
],
v38 = [
  {
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v21/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v17/*: any*/),
          {
            "kind": "ScalarField",
            "name": "planId"
          },
          {
            "kind": "ScalarField",
            "name": "title"
          },
          {
            "kind": "ScalarField",
            "name": "isReadOnly"
          },
          {
            "kind": "ScalarField",
            "name": "planStatus"
          },
          {
            "concreteType": "JiraFavouriteValue",
            "kind": "LinkedField",
            "name": "favouriteValue",
            "plural": false,
            "selections": [
              (v30/*: any*/),
              (v17/*: any*/)
            ]
          },
          {
            "concreteType": "JiraScenario",
            "kind": "LinkedField",
            "name": "scenario",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "scenarioId"
              },
              (v17/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "name": "defaultNavigationItem",
            "plural": false,
            "selections": [
              (v21/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v37/*: any*/),
                "type": "JiraSoftwareBuiltInNavigationItem"
              },
              (v33/*: any*/)
            ]
          }
        ],
        "type": "JiraPlan"
      },
      (v33/*: any*/)
    ]
  }
],
v39 = {
  "alias": "projectKey",
  "kind": "ScalarField",
  "name": "key"
},
v40 = {
  "kind": "ScalarField",
  "name": "status"
},
v41 = {
  "kind": "ScalarField",
  "name": "projectType"
},
v42 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "large"
    }
  ]
},
v43 = {
  "kind": "ScalarField",
  "name": "projectId"
},
v44 = {
  "kind": "LinkedField",
  "name": "defaultNavigationItem",
  "plural": false,
  "selections": [
    (v21/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v37/*: any*/),
      "type": "JiraNavigationItem",
      "abstractKey": "__isJiraNavigationItem"
    },
    (v33/*: any*/)
  ]
},
v45 = {
  "args": [
    {
      "kind": "Literal",
      "name": "type",
      "value": "EDIT_PROJECT_CONFIG"
    }
  ],
  "concreteType": "JiraProjectAction",
  "kind": "LinkedField",
  "name": "action",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "canPerform"
    }
  ],
  "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
},
v46 = {
  "kind": "ScalarField",
  "name": "projectStyle"
},
v47 = {
  "kind": "ScalarField",
  "name": "softwareBoardCount"
},
v48 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v49 = [
  (v17/*: any*/),
  (v39/*: any*/),
  (v40/*: any*/),
  (v41/*: any*/),
  (v42/*: any*/),
  (v29/*: any*/),
  (v43/*: any*/),
  (v30/*: any*/),
  (v44/*: any*/),
  (v45/*: any*/),
  (v46/*: any*/),
  (v47/*: any*/),
  (v48/*: any*/)
],
v50 = {
  "concreteType": "JiraProjectEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "concreteType": "JiraProject",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": (v49/*: any*/)
    }
  ]
},
v51 = [
  (v50/*: any*/),
  (v34/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GSNForContentSidebarQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "useNetworkSideNavUserData"
      },
      {
        "alias": "navPlatL1MenuData",
        "args": (v13/*: any*/),
        "concreteType": "SettingsNavigationCustomisation",
        "kind": "LinkedField",
        "name": "settings_navigationCustomisation",
        "plural": false,
        "selections": (v14/*: any*/)
      },
      {
        "alias": "navPlatSidebarData",
        "args": (v15/*: any*/),
        "concreteType": "SettingsNavigationCustomisation",
        "kind": "LinkedField",
        "name": "settings_navigationCustomisation",
        "plural": false,
        "selections": (v14/*: any*/)
      },
      {
        "kind": "FragmentSpread",
        "name": "Nav4Apps"
      },
      {
        "kind": "FragmentSpread",
        "name": "Nav4Filters"
      },
      {
        "kind": "FragmentSpread",
        "name": "Nav4Operations"
      },
      {
        "kind": "FragmentSpread",
        "name": "Nav4Overviews"
      },
      {
        "kind": "FragmentSpread",
        "name": "Nav4Plans"
      },
      {
        "kind": "FragmentSpread",
        "name": "Nav4Projects"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgrw1672displaytargetedjsmtemplatectainnav4relayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6314draganddropprojectssidebarexperimentrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "GSNForContentSidebarQuery",
    "selections": [
      {
        "alias": "userSideNavSettings",
        "args": [
          {
            "kind": "Variable",
            "name": "entityAri",
            "variableName": "entityAriUserSideNavSettings"
          },
          (v12/*: any*/)
        ],
        "concreteType": "SettingsNavigationCustomisation",
        "kind": "LinkedField",
        "name": "settings_navigationCustomisation",
        "plural": false,
        "selections": (v18/*: any*/)
      },
      {
        "alias": "navPlatL1MenuData",
        "args": (v13/*: any*/),
        "concreteType": "SettingsNavigationCustomisation",
        "kind": "LinkedField",
        "name": "settings_navigationCustomisation",
        "plural": false,
        "selections": (v18/*: any*/)
      },
      {
        "alias": "navPlatSidebarData",
        "args": (v15/*: any*/),
        "concreteType": "SettingsNavigationCustomisation",
        "kind": "LinkedField",
        "name": "settings_navigationCustomisation",
        "plural": false,
        "selections": (v18/*: any*/)
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "isAppsExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v20/*: any*/),
                "concreteType": "JiraNavigationItemConnection",
                "kind": "LinkedField",
                "name": "globalAppNavigationItems",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraNavigationItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          (v17/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v22/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "appId"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "appType"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "envLabel"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "iconUrl"
                              },
                              (v23/*: any*/),
                              {
                                "concreteType": "JiraAppSection",
                                "kind": "LinkedField",
                                "name": "sections",
                                "plural": true,
                                "selections": [
                                  (v22/*: any*/),
                                  {
                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": true,
                                    "selections": [
                                      (v22/*: any*/),
                                      (v24/*: any*/),
                                      (v23/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "settingsUrl"
                              },
                              (v24/*: any*/)
                            ],
                            "type": "JiraAppNavigationItem"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "isFiltersExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "hasIsFiltersExpanded",
                "kind": "ScalarField",
                "name": "__typename"
              }
            ]
          },
          {
            "args": (v20/*: any*/),
            "concreteType": "JiraWorkManagementGiraOverviewConnection",
            "kind": "LinkedField",
            "name": "jwmOverviews",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "totalCount"
              }
            ]
          },
          {
            "condition": "isProjectsExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "hasIsProjectsExpanded",
                "kind": "ScalarField",
                "name": "__typename"
              }
            ]
          },
          {
            "alias": "canCreateProject",
            "args": [
              (v19/*: any*/),
              {
                "kind": "Literal",
                "name": "type",
                "value": "CREATE_PROJECT"
              }
            ],
            "kind": "ScalarField",
            "name": "canPerform"
          },
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "shouldDisplay",
                "args": [
                  (v19/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "VIEW_PROJECT_CREATION_ENTRY"
                  }
                ],
                "kind": "ScalarField",
                "name": "canPerform"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "isPlansExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "hasIsPlansExpanded",
                "kind": "ScalarField",
                "name": "__typename"
              }
            ]
          },
          {
            "args": (v20/*: any*/),
            "concreteType": "JiraAdvancedRoadmapsNavigation",
            "kind": "LinkedField",
            "name": "advancedRoadmapsNavigation",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hasEditPermissions"
              },
              {
                "kind": "ScalarField",
                "name": "hasCreateSamplePlanPermissions"
              },
              {
                "kind": "ScalarField",
                "name": "hasGlobalPlansAdminPermissions"
              }
            ]
          }
        ]
      },
      {
        "condition": "isFiltersExpanded",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "alias": "favouriteFilters",
                "args": [
                  (v19/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "sort": (v25/*: any*/),
                      "type": "FILTER"
                    }
                  },
                  (v26/*: any*/)
                ],
                "concreteType": "JiraFavouriteConnection",
                "kind": "LinkedField",
                "name": "favourites",
                "plural": false,
                "selections": [
                  (v27/*: any*/),
                  {
                    "concreteType": "JiraFavouriteEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v28/*: any*/),
                              (v29/*: any*/),
                              (v17/*: any*/),
                              (v30/*: any*/),
                              (v31/*: any*/),
                              (v32/*: any*/)
                            ],
                            "type": "JiraFilter",
                            "abstractKey": "__isJiraFilter"
                          },
                          (v33/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v34/*: any*/)
                ]
              },
              {
                "alias": "recentFilters",
                "args": [
                  (v19/*: any*/),
                  (v35/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "types",
                    "value": [
                      "FILTER"
                    ]
                  }
                ],
                "concreteType": "JiraSearchableEntityConnection",
                "kind": "LinkedField",
                "name": "recentItems",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraSearchableEntityEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v28/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v29/*: any*/),
                                  (v17/*: any*/),
                                  (v30/*: any*/),
                                  (v31/*: any*/),
                                  (v32/*: any*/)
                                ],
                                "type": "JiraFilter",
                                "abstractKey": "__isJiraFilter"
                              }
                            ],
                            "type": "JiraCustomFilter"
                          },
                          (v33/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v34/*: any*/)
                ]
              },
              {
                "args": (v20/*: any*/),
                "concreteType": "JiraSystemFilterConnection",
                "kind": "LinkedField",
                "name": "systemFilters",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraSystemFilterEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraSystemFilter",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v28/*: any*/),
                          (v17/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v29/*: any*/),
                              (v21/*: any*/),
                              (v30/*: any*/),
                              (v31/*: any*/),
                              (v32/*: any*/)
                            ],
                            "type": "JiraFilter",
                            "abstractKey": "__isJiraFilter"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "isOperationsExpanded",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "OpsgenieQuery",
            "kind": "LinkedField",
            "name": "opsgenie",
            "plural": false,
            "selections": [
              {
                "args": (v20/*: any*/),
                "concreteType": "OpsgenieSavedSearches",
                "kind": "LinkedField",
                "name": "savedSearches",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "OpsgenieSavedSearch",
                    "kind": "LinkedField",
                    "name": "sharedWithMe",
                    "plural": true,
                    "selections": (v36/*: any*/)
                  },
                  {
                    "concreteType": "OpsgenieSavedSearch",
                    "kind": "LinkedField",
                    "name": "createdByMe",
                    "plural": true,
                    "selections": (v36/*: any*/)
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "isOverviewsExpanded",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": (v20/*: any*/),
                "concreteType": "JiraWorkManagementGiraOverviewConnection",
                "kind": "LinkedField",
                "name": "jwmOverviews",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraWorkManagementGiraOverviewEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraWorkManagementGiraOverview",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v17/*: any*/),
                          (v29/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "isPlansExpanded",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "alias": "favouritePlans",
                "args": [
                  (v19/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "sort": (v25/*: any*/),
                      "type": "PLAN"
                    }
                  },
                  (v26/*: any*/)
                ],
                "concreteType": "JiraFavouriteConnection",
                "kind": "LinkedField",
                "name": "favourites",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraFavouriteEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": (v38/*: any*/)
                  },
                  (v34/*: any*/)
                ]
              },
              {
                "alias": "recentPlans",
                "args": [
                  (v19/*: any*/),
                  (v35/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "types",
                    "value": [
                      "PLAN"
                    ]
                  }
                ],
                "concreteType": "JiraSearchableEntityConnection",
                "kind": "LinkedField",
                "name": "recentItems",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraSearchableEntityEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": (v38/*: any*/)
                  },
                  (v34/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "isProjectsExpanded",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": (v20/*: any*/),
                "concreteType": "JiraWorkManagementLicensing",
                "kind": "LinkedField",
                "name": "jwmLicensing",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "currentUserSeatEdition"
                  }
                ]
              },
              {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                  {
                    "alias": "favouriteProjects",
                    "args": [
                      (v19/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "sort": (v25/*: any*/),
                          "type": "PROJECT"
                        }
                      },
                      (v26/*: any*/)
                    ],
                    "concreteType": "JiraFavouriteConnection",
                    "kind": "LinkedField",
                    "name": "favourites",
                    "plural": false,
                    "selections": [
                      (v27/*: any*/),
                      {
                        "concreteType": "JiraFavouriteEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v49/*: any*/),
                                "type": "JiraProject"
                              },
                              (v33/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v34/*: any*/)
                    ]
                  },
                  {
                    "args": [
                      (v19/*: any*/),
                      (v35/*: any*/)
                    ],
                    "concreteType": "JiraProjectConnection",
                    "kind": "LinkedField",
                    "name": "recentProjects",
                    "plural": false,
                    "selections": (v51/*: any*/)
                  }
                ]
              }
            ]
          },
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "entityAri",
                        "variableName": "entityAriProjects"
                      },
                      (v12/*: any*/)
                    ],
                    "concreteType": "SettingsNavigationCustomisation",
                    "kind": "LinkedField",
                    "name": "settings_navigationCustomisation",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v17/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v20/*: any*/),
                "concreteType": "JiraProjectsSidebarMenu",
                "kind": "LinkedField",
                "name": "jira_projectsSidebarMenu",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "mostRecent",
                    "plural": false,
                    "selections": (v49/*: any*/)
                  },
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "mostRecentFromHistory",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      (v39/*: any*/),
                      (v30/*: any*/),
                      (v40/*: any*/),
                      (v41/*: any*/),
                      (v42/*: any*/),
                      (v29/*: any*/),
                      (v43/*: any*/),
                      (v44/*: any*/),
                      (v45/*: any*/),
                      (v46/*: any*/),
                      (v47/*: any*/),
                      (v48/*: any*/)
                    ]
                  },
                  {
                    "args": [
                      (v26/*: any*/)
                    ],
                    "concreteType": "JiraProjectConnection",
                    "kind": "LinkedField",
                    "name": "favourites",
                    "plural": false,
                    "selections": [
                      (v27/*: any*/),
                      (v50/*: any*/),
                      (v34/*: any*/)
                    ],
                    "storageKey": "favourites(first:15)"
                  },
                  {
                    "args": [
                      (v35/*: any*/)
                    ],
                    "concreteType": "JiraProjectConnection",
                    "kind": "LinkedField",
                    "name": "recents",
                    "plural": false,
                    "selections": (v51/*: any*/),
                    "storageKey": "recents(first:20)"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasMore"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "favouriteLimit"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "recentLimit"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "displayMode"
                  },
                  (v17/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "e0ad4f1c57fdb45b512c8a9f04e15dd64287d9fc05258fda5b73a81f4e9bc36d",
    "metadata": {},
    "name": "GSNForContentSidebarQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider": isAllowingEndUsersToAccessCustomTemplates_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcgrw1672displaytargetedjsmtemplatectainnav4relayprovider": nav4ProjectsSectionRecommendationEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider": displaySettingsAPart1Enabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider": displaySettingsPostGaEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider": jiraProjectsSidebarMenuEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider": isJcsProjectMenuEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx": isJpdNav4CommonEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": checkForA11YEnabledFF_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcblu6314draganddropprojectssidebarexperimentrelayprovider": isDragAndDropEnabled_provider
    }
  }
};
})();

(node as any).hash = "105ccc68c10e80789d437d04e78517f3";

export default node;
